import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import {} from '../models/deployment-workflow-node';
import { DeploymentHistoryService } from '../services/deployment-history.service';
import { DeploymentHistoryRecord } from '@definitions/deployments';

export const deploymentWorkflowResolver = (
	route: ActivatedRouteSnapshot
): Observable<DeploymentHistoryRecord> => {
	const deployHistorySvc = inject(DeploymentHistoryService);

	const id = route.paramMap.get('id');
	const applicationId = route.queryParamMap.get('applicationId') ?? undefined;

	return deployHistorySvc.find(id, applicationId).pipe(
		catchError((error) => {
			console.error('Failed to load deployment workflow', error);
			return of(null);
		})
	);
};
